

module.directive('inlineFollowup', function($q, ModelService, FollowupService,
                                            Notifications) {
    return {
        restrict: 'E',
        templateUrl: 'students/followup/inlineFollowupDirective',
        scope: {
            placement: '='
        },
        link: function(scope, element, attrs) {
            var model_name = scope.placement.$model_name,
                usubscribe;


            function update(placement_id) {
                if (placement_id !== scope.placement.id) return;
                scope.data = {}

                FollowupService.loadFollowup(model_name, placement_id)
                    .then(function(followup) {
                        scope.followup = followup;
                    });
            }

            scope.save = function(form, data) {
                var success, msg;
                if (!form.$valid) {
                    Notifications.canned('form_errors');
                    return $q.reject();
                }
                success = data.action === 'verify';
                return FollowupService.createPlacementFollowup(
                    scope.placement.participant_id,
                    scope.placement, success,
                    data.date).then(function() {
                        // Not needed because listenForChanges will handle it
                        // update(scope.placement.id);
                        msg = success ? "Verified" : "marked as unable to verify.";
                        Notifications.success("Placement " + msg);
                        form.$setPristine();
                    });
            }

            unsubscribe = ModelService.listenForChanges(model_name, update);
            scope.$on('$destroy', unsubscribe);
            update(scope.placement.id);
        },
    };
});
